import React, { useState, useEffect } from 'react';
import SearchBar from './components/SearchBar/SearchBar';
import Listing from './components/Listing/Listing';
import Radio from './components/Radio/Radio';
import ChooseCountry, { sFn } from './components/ChooseCountry/ChooseCountry';
import RadioConfigContext from './context/RadioConfigContext/RadioConfigContext';
import useRadioConfig from './context/RadioConfigContext/useRadioConfig';
import CategoryChooser from './components/CategoryChooser/CategoryChooser';
import { getCategories, ICategory, availableCountries } from './api';
import BeatLoader from "react-spinners/BeatLoader";
import { AppBox, SearchBarBox, MainLoading, HeartButton } from './App.css';

declare global {
  interface External {
    notify: (val: string) => void
  }
}

export const storageKey = '@favourites';

const App = (): JSX.Element => {
  const [inputValue, _setInputValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [showFavs, setShowFavs] = useState(false);
  const [currentCategories, setCurrentCategories] = useState<ICategory[]>([]);
  const setInputValue = (value: string) => {
    _setInputValue(value);
  }
  const radioConfig = useRadioConfig();

  const getUserInfo = async () => {
    const data = await fetch('http://188.165.221.101:3002/getLocalisation/?a=' + Date.now());
    return await data.json();
  };

  useEffect(() => {
    (async function() {
      const userInfo = await getUserInfo();
      const countryCode = (userInfo.data.country as string).toLowerCase();
      const find = availableCountries.findIndex(x => x.code === countryCode);
      const favourites = window.localStorage.getItem(storageKey);
      if (!favourites) {
        window.localStorage.setItem(storageKey, JSON.stringify([]));
      }
      console.log(favourites);
      if (find > -1) {
        radioConfig.setRadioConfig({...radioConfig.radioConfig, lang: countryCode});
      }
      const categories = await getCategories(countryCode);
      setCurrentCategories(categories.sort(sFn));
      setLoading(false);
    })();
  }, [])

  useEffect(() => {
    (async function() {
      if (!loading) {
        const categories = await getCategories(radioConfig.radioConfig.lang);
        console.log(categories);
        setCurrentCategories(categories);
      }
    })();
  }, [radioConfig.radioConfig.lang]);

  if (loading) {
    return (
      <MainLoading>
        <BeatLoader color="#999" size={30} loading={true} />
      </MainLoading>
    );
  }

  const handleToggleFavs = () => {
    radioConfig.setRadioConfig({...radioConfig.radioConfig, currentCategory: 0, currentCategoryName: ''});
    setShowFavs(!showFavs);
  }

  return (
    <RadioConfigContext.Provider value={radioConfig}>
      <AppBox>
        <SearchBarBox>
          <CategoryChooser setShowFavs={setShowFavs} categories={currentCategories} />
          <HeartButton showFavs={showFavs} onClick={handleToggleFavs} style={{}}>
            <i className="fa fa-heart" />
          </HeartButton>
          <SearchBar inputValue={inputValue} setInputValue={setInputValue} />
          <ChooseCountry setShowFavs={setShowFavs} />
        </SearchBarBox>
        <Listing inputValue={inputValue} showFavs={showFavs} />
        <Radio />
      </AppBox>
    </RadioConfigContext.Provider>
  );
};

export default App;